import React from 'react'
import PropTypes from 'prop-types'
import Turbolinks from 'turbolinks'
import PlatinumInfoModal from './PlatinumInfoModal'
import BookshelfInfoModal from './BookshelfInfoModal'
import { Message, MessageBody, Button, SecondaryButton, Level, LevelItem, LevelLeft } from '../../bulma'
import { CheckboxIcon } from '../../core/icons'

class OrderSubscription extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isChecked: props.order.deseret_book_order_subscriptions.filter(sub => sub.subscription_plan_id == props.subscription.id).length == 1,
      subscription: props.order.deseret_book_order_subscriptions.filter(sub => sub.subscription_plan_id == props.subscription.id)[0],
      showModal: false,
    }

    this.onClickHandler = this.onClickHandler.bind(this)
    this.renderSubscriptionModal = this.renderSubscriptionModal.bind(this)
  }

  onClickHandler(e) {
    const { order, subscription, handlePlatinumAdded } = this.props

    handlePlatinumAdded()

    if (this.state.subscription) {
      $.ajax({
        type: 'DELETE',
        url: `/api/order_subscriptions/${this.state.subscription.id}`,
        success: () => {
          this.setState({ subscription: null })
          this.setState(prevState => ({
            isChecked: !prevState.isChecked,
          }))
        },
        error: () => {
          this.setState(prevState => ({
            isChecked: !prevState.isChecked,
          }))
        },
      })
    } else {
      $.ajax({
        type: 'POST',
        url: '/api/order_subscriptions',
        data: { order_id: order.id, subscription_plan_id: subscription.id },
        success: (response) => {
          this.setState({ subscription: response.data.order_subscription })
          this.setState(prevState => ({
            isChecked: !prevState.isChecked,
          }))
        },
        error: (response) => {
          if (response.responseJSON.code == 1) {
            Turbolinks.visit('/login')
          } else if (response.responseJSON.code == 2) {

          } else {
            this.setState(prevState => ({
              isChecked: !prevState.isChecked,
            }))
          }
        },
      })
    }
  }

  renderSubscriptionModal() {
    if (this.props.subscription.bt_plan_id == '4749320' && this.props.order.user && !this.props.order.user['platinum?']) {
      return (
        <PlatinumInfoModal
          checkoutStep={this.props.checkoutStep}
        />
      )
    } else if (this.props.subscription.bt_plan_id == 'tqh6') {
      return (
        <BookshelfInfoModal
          checkoutStep={this.props.checkoutStep}
        />
      )
    }
  }

  render() {
    const {
      logo, mainText, checkText, subText, subscription, order, checkoutStep, handlePlatinumAdded, ...rest
    } = this.props

    return (
      <div className="order-subscription-panel">
        <Message>
          <MessageBody className="has-text-left">
            <div>
              {logo}
            </div>
            <br />
            <div>
              {mainText}
              { this.renderSubscriptionModal() }
            </div>
            <br />
            <div>
              <div>
                {order.user
                  ? checkText
                    ? <Button type="button" isText onClick={this.onClickHandler} eventCategory="Checkout" eventAction={`${subscription.name} Signup`} eventLabel={`${checkoutStep} | ${!this.state.isChecked ? 'Add' : 'Remove'}`} trackEvent>
                      <Level isMobile>
                        <LevelLeft>
                          <LevelItem><CheckboxIcon isOn={this.state.isChecked} /> </LevelItem>
                          <LevelItem>{checkText}</LevelItem>
                        </LevelLeft>
                      </Level>
                      </Button>
                    : false
                  : <div className="has-text-centered">
                    <SecondaryButton type="button" href="/login" isOutlined linkRef="subscription-signup" eventCategory="Checkout" eventAction={`${subscription.name} Signup`} eventLabel={`${checkoutStep} | Login`} trackEvent>Login to sign up</SecondaryButton>
                    </div>
                }
              </div>
            </div>
            { subText ? <br /> : false }
            <small>
              {subText}
            </small>
          </MessageBody>
        </Message>
      </div>
    )
  }
}

OrderSubscription.defaultProps = {
  order: {},
  subscription: {},
  logo: {},
  mainText: {},
  checkText: {},
  subText: {},
  checkoutStep: '',
  handlePlatinumAdded() {},
}

OrderSubscription.propTypes = {
  // The order that is being placed
  order: PropTypes.object,
  // The subscription plan
  subscription: PropTypes.object,
  // The logo to be displayed
  logo: PropTypes.object,
  // The main text to be displayed
  mainText: PropTypes.object,
  // The text to disply by the checkbox
  checkText: PropTypes.object,
  // The terms and conditions
  subText: PropTypes.object,
  // The step of checkout
  checkoutStep: PropTypes.string,
  // Function to change pricing if platinum sub is added
  handlePlatinumAdded: PropTypes.func,
}

export default OrderSubscription
